import React from "react";
import { useNavigate } from "react-router-dom";
import "./Auth.css";

export const DeviceNameStep = ({
  setIsTabClick,
  setIsDeviceName,
  setCurrentRoute,
  setDeviceName,
  deviceName,
}) => {
  const navigate = useNavigate();

  const handleSubmit = () => {
    if (!deviceName.trim()) {
      alert("Please enter a device name");
      return;
    }

    navigate("/QRCodeAuthentication");
    setCurrentRoute("QRCodeAuthentication");
    setIsDeviceName(true);
    setIsTabClick(true);
  };

  const handleKeyDown = (event) => {
    if (event.keyCode === 13 || event.which === 13) {
      handleSubmit();
    }
  };

  return (
    <div className="row login-start login-page-shell">
      <div className="col-12">
        <div className="login-layout login-layout--centered">
          <section className="login-form-panel login-form-panel--centered auth-flip-card glass-panel setting-login auth-stack-panel">
            <div className="login-form-header">
              <p className="login-form-eyebrow">Set Up Multi-Factor Authentication</p>
              <p className="login-form-subtitle">
                Name this device before generating the authenticator QR code.
              </p>
            </div>

            <div className="auth-section-card">
              <div className="auth-section-card__copy">
                <span className="auth-section-card__eyebrow">Step 1</span>
                <h3>Name your device</h3>
                <p>
                  Use a label that makes it easy to identify where this sign-in is
                  being configured.
                </p>
              </div>

              <div className="auth-form-field auth-form-field--compact">
                <label htmlFor="deviceName" className="login-field-label">
                  Device Name
                </label>
                <input
                  id="deviceName"
                  type="text"
                  value={deviceName}
                  onChange={(event) => setDeviceName(event.target.value)}
                  onKeyDown={handleKeyDown}
                  placeholder="Work laptop"
                  className="login-field-input form-control"
                />
              </div>
            </div>

            <div className="login-action-stack">
              <button
                onClick={handleSubmit}
                type="button"
                className="simple-btn login-btn form-hidden login-submit-btn"
              >
                Continue
              </button>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};
